import { type Options } from '@glidejs/glide';

function EmptySearch() {
  const width = $(window).width() || 0;

  const init = () => {
    sliderShelf();
  };

  const sliderShelf = () => {
    const $container = $('.emptysearch__shelf .shelf');
    const $ul = $container.find('> ul');

    const $li = $ul.find('li');
    $container.addClass('shelf-loaded');
    $ul.addClass('glide__slides');
    $ul.wrapAll('<div class="glide__track" data-glide-el="track"> </div>');
    $li.addClass('glide__slide');
    $container.addClass('glide emptysearch__shelf__item');

    const config = {
      type: 'carousel',
      autoplay: 8000,
      showDots: true,
      perView: 4,
      perSwipe: '|',
      breakpoints: {
        1024: {
          perView: 2,
          perSwipe: '|',
        },
      },
    } as unknown as Options;

    const top = $container.find('.productImage').height();
    $container.find('.glide__arrows > button').attr('style', `--top:${top}px`);

    const mountedSlider = window.aguadecoco.helpers.slider('.emptysearch__shelf__item', config, true);
    $container.parent().removeClass('shelf-not-loaded');

    if (width <= 1204) {
      mountedSlider.update({
        peek: {
          before: 0,
          after: 50,
        },
      });
    }
  };

  init();
}

EmptySearch();
